
  import { Vue, Component, Prop } from "vue-property-decorator";
  import { Contractor } from "@/generated/graphql";
  import RouteParams from "@/entities/RouteParams";
  import RouteNames from "@/entities/RouteNames";

  @Component
  export default class CompanyContractorProvider extends Vue {
    @Prop({ type: Object, default: undefined }) readonly contractor!: Contractor;
    @Prop({ type: String, default: undefined }) readonly contractorUserId!: string;

    get contractorId(): string | undefined {
      return this.contractor?.id;
    }

    get belongsToCompany(): boolean | undefined {
      if (!this.contractor) {
        return false;
      }

      const contractorDeleted = this.contractor.deleted;
      const contractorApproved = this.contractor.approved;
      return !contractorDeleted && contractorApproved;
    }

    get publicPageRouteParams(): RouteParams<{id: string}> {
      return {
        name: RouteNames.CONTRACTOR_PUBLIC_PAGE,
        params: {
          id: this.contractorUserId,
        },
      };
    }
  }
